import React from 'react';
import styled from 'styled-components';

export enum CmsPopupBtnType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  DANGER = 'danger',
}

interface CmsPopupBtnProps {
  type?: CmsPopupBtnType;
  children: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

const StyledButton = styled.button<{ $type: CmsPopupBtnType; $disabled?: boolean }>`
  width: 100px;
  height: 40px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
  
  ${({ $type }) => {
    if ($type === CmsPopupBtnType.PRIMARY) {
      return `
        background-color: #393c53;
        color: white;
        border: 1px solid #393c53;
        
        &:hover:not(:disabled) {
          background-color: #2c2f42;
          border-color: #2c2f42;
        }
      `;
    } else if ($type === CmsPopupBtnType.DANGER) {
      return `
        background-color: #dc3545;
        color: white;
        border: 1px solid #dc3545;
        
        &:hover:not(:disabled) {
          background-color: #c82333;
          border-color: #c82333;
        }
      `;
    } else {
      return `
        background-color: white;
        color: #393c53;
        border: 1px solid #393c53;
        
        &:hover:not(:disabled) {
          background-color: #f8f9fa;
        }
      `;
    }
  }}
`;

const CmsPopupBtn: React.FC<CmsPopupBtnProps> = ({
  type = CmsPopupBtnType.PRIMARY,
  children,
  onClick,
  disabled = false,
}) => {
  return (
    <StyledButton
      $type={type}
      $disabled={disabled}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </StyledButton>
  );
};

export default CmsPopupBtn;
